var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"ta-lot-title",domProps:{"innerHTML":_vm._s(_vm.$options.filters.stripTags(_vm.$options.filters.currentLocale(_vm.lot.title)))}})}
var staticRenderFns = []

export { render, staticRenderFns }